<template>
  <section v-if="!isReady || isGetRequestPending" class="messages">
    <p-loading />
  </section>

  <section v-else class="messages">
    <header>
      <h1>Messages</h1>
      <section class="action-wrapper">
        <router-link v-if="$hasPermission('messages')" to="/messages/create">+ new</router-link>
      </section>
    </header>
    <section>
      <p-list
        name="messages"
        :data="collection"
        :total="total"
        :metadata="{
          name: { label: 'Name', width: 'minmax(0, 3fr)' },
          description: { label: 'Description', width: 'minmax(0, 3fr)' },
          organizations: { label: 'Organizations', width: 'minmax(100px, 2fr)', labelCallback: getOrganizationName },
          tags: { label: 'Tags', width: 'minmax(100px, 2fr)' },
          modifiedAt: { label: 'Last modification', width: '175px' }
        }"
        @edit="edit"
      >
        <template #__actions="{ item }">
          <p-button v-if="$hasPermission('messages')" variant="text" title="Clone this message" style="font-size: 1.25rem" @click="clone(item.id)">
            &#x2398;</p-button
          >
          <p-button variant="text" title="Edit this message" @click="edit(item.id)"> &#9998;</p-button>
        </template>
      </p-list>
    </section>
  </section>
</template>

<script>
import { mapState } from 'vuex';

import Button from './../common/Button';
import Loading from './../common/Loading';
import List from './../common/List';

export default {
  components: {
    'p-list': List,
    'p-loading': Loading,
    'p-button': Button
  },
  data() {
    return {
      isReady: false
    };
  },
  computed: {
    ...mapState({
      collection: s => s.messages.collection,
      total: s => s.messages.total,
      isGetRequestPending: s => s.messages.isGetRequestPending,
      organizationsCollection: s => s.organizations.collection
    })
  },
  async created() {
    await Promise.all([
      this.$store.dispatch('organizations/getCollection').catch(() => undefined),
      this.$store.dispatch('messages/getCollection')
    ]);
    this.isReady = true;
  },
  methods: {
    async edit(id) {
      this.$router.push({ path: `/messages/${id}/edit` });
    },
    async clone(id) {
      const lock = this.$lock();

      try {
        const message = await this.$store.dispatch('messages/clone', { id });

        this.$toast.success({
          title: 'Clone completed',
          message: `Message '${message.name}' was created.`
        });
      } catch (e) {
        this.$toast.error({
          title: 'Clone failed',
          message: `Please, try again later or contact our development team.`
        });
      } finally {
        lock.release();
      }
    },
    getOrganizationName(id) {
      return this.organizationsCollection.find(o => o.id === id)?.name ?? id;
    }
  }
};
</script>

<style scoped lang="scss">
.messages {
  display: grid;
  padding: 0 0.5rem 0 1rem;
  grid-template-columns: 1fr;
  grid-template-rows: max-content minmax(0, 1fr);
  grid-gap: 0.5rem;
  width: 100%;
  height: 100%;

  > header {
    padding: 0.5rem 0.5rem 0;
    display: flex;
    justify-content: space-between;

    box-sizing: border-box;
    h1 {
      color: var(--theme-on-surface);
      font-size: 1.5rem;
      font-weight: 700;
      margin-right: 0.25rem;
    }

    .action-wrapper {
      display: flex;
      justify-content: flex-end;
      align-items: center;
    }
  }
}
</style>
